import { useContext } from "react";

import { dragActiveStyle } from "./constants";
import { DragIndexContext } from "./context";
import { BodyCellProps, DragIndexState } from "./type";
import { EditableCell } from "../Editable/EditableCell";

interface TableBodyCellProps extends BodyCellProps {
    editingRowId: string | null;
    editable: boolean;
    dataIndex: string;
    inputType: string;
}

export const HorizontalTableBodyCell: React.FC<TableBodyCellProps> = (props) => {
    const { style, children, ...restProps } = props;
    const dragState = useContext<DragIndexState>(DragIndexContext);

    return (
        <EditableCell
            editing={props.editable && props.id === props?.editingRowId}
            style={{ ...style, ...dragActiveStyle(dragState, props.id) }}
            {...restProps}
        >
            {children}
        </EditableCell>
    );
};

export const VerticalTableBodyCell: React.FC<TableBodyCellProps> = (props) => {
    const { style, children, ...restProps } = props;
    return (
        <EditableCell editing={props.editable && props.id === props?.editingRowId} style={style} {...restProps}>
            {children}
        </EditableCell>
    );
};
